export default "__VITE_PUBLIC_ASSET__a92c82b8__"